module.exports = __webpack_public_path__ + "media/images/ninestars/portfolio/portfolio-9-561bb1f26fc76bc36f6c0af50b52d9fb.jpg";